'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _url = require('../../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formValues) {
  var applicants = formValues.applicants;


  applicants.forEach(function (applicant, index) {
    applicant.additional_data.policy_type = formValues.application.additional_data.form_type === 'group' && formValues.application.additional_data.dependent_medical_coverage === '0' ? 'single' : applicant.additional_data.policy_type;
  });

  return formValues.applicants;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/msh/livexpat/applicants.js
// module id = 1746
// module chunks = 0